export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const COD_MAX_ORDER_VALUE = 5000; // Maximum allowed value for COD orders